import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './UploadAvatar.css'; // Your custom styles

import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';

function ISSNPage() {
    const [showMenu, setShowMenu] = useState(false);
    const [scrolling, setScrolling] = useState(false);

    const toggleMenu = () => {
        setShowMenu(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>


            <NRDRUHSHeader />

            <Helmet>
                <link rel="canonical" href="https://nrdruh.in/editorialboard" />
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            {/* ISSN Content */}
            <div className="container" style={{ paddingTop: 60 }}>
                <h2 className="text-center mb-4" style={{ fontWeight: 'bold' }}>Editorial Board</h2>
            </div>

            <div className="container">
                <div className="row" style={{ marginBottom: 120 }}>
                    <div className="col-md-2" style={{ padding: 30 }}></div>

                    <div className="col-md-8" style={{ padding: 15, textAlign: 'center' }}>
                        <p style={{ textAlign: 'center', fontWeight: 'bold', lineHeight: 3 }}>
                            Dr. Anjali Kapoor<br />
                            Dr. Anupama Gaur<br />
                            Dr. Chandni Shekhawat<br />
                            Dr. Jyoti Paliwal<br />
                            Dr. Sankalp Mittal<br />
                            Dr. Seema Chaudary<br />
                            Dr. Shahina Parvez<br />
                            Dr. Sharmistha Vijay<br />
                            Dr. Sumit Bhansali<br />
                            Dr. S.K. Sireesha

                            <br />
                        </p>
                    </div>

                    <div className="col-md-2" style={{ padding: 15 }}></div>
                </div>
            </div>

            <NRDRUHSFooter />
        </div>
    );
}

export default ISSNPage;
